module.exports = __webpack_public_path__ + "flyer_background_prism_124-f7e5699daf037d0701a1ce2efad2b771.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_prism_124.jpg
// module id = 1677
// module chunks = 1